<template>
<div>
  <el-form style="margin-right: 30px" :model="addEditForm" :rules="addEditRules" ref="addEditForm" label-width="100px" class="demo-ruleForm">
    <el-form-item label="项目名称" prop="">
      <el-input v-model="addEditForm.val" placeholder="请输入项目名称"></el-input>
    </el-form-item>
    <el-form-item label="收费金额" prop="">
      <el-input type="number" v-model="addEditForm.val" placeholder="请输入收费金额（元）"></el-input>
    </el-form-item>
    <el-form-item label="备注" prop="">
      <el-input type="textarea" :rows="2" v-model="addEditForm.name" placeholder="请输入备注"></el-input>
    </el-form-item>
  </el-form>
  <div style="height: 50px">
    <el-row style="margin: 0 20px">
      <el-col :span="12">
        <div class="cancel-btn" @click="closeAddEdit()">
          <span>取消</span>
        </div>
      </el-col>
      <el-col :span="12">
        <div class="send-btn" @click="submitAddEditUnit('addEditForm')">
          <span>确定</span>
        </div>
      </el-col>
    </el-row>
  </div>
</div>
</template>

<script>
export default {
  name: 'addEditPrice',
  model: {
    prop: 'addShow',
    event: 'change'
  },
  props: {
    addEditObj: {
      type: Object,
      default: null
    }
  },
  data () {
    return {
      oldPersonArr: [],
      projectArr: [],
      addEditForm: {
        val: '',
        time: '',
        name: ''
      },
      addEditRules: {}
    }
  },
  methods: {
    closeAddEdit () {
      this.$emit('change', false)
    },
    submitAddEditUnit (formName) {
      this.$refs[formName].validate((valid) => {
      })
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/oldPersonHome/components/addEditPrice.vue